import * as UI from "@iyk/music-ui"

export const Meta = UI.Meta.withDefaults({
  title: "IYK x Discord",
  description: "Claim rewards in Discord",
  image: "https://assets.iyk.app/music/iyk-music-og.jpg",
  url: "https://music-discord-bot.iyk.app", // TODO: update this to the actual URL
  domain: "iyk.app"
})
